// src/excel/core/excelService.js
// Ленивая загрузка SheetJS (xlsx) и единая точка экспорта .xlsx
let _xlsxPromise = null;
async function loadXlsx() {
  if (!_xlsxPromise) {
    _xlsxPromise = import('xlsx').then(m => m.default || m);
  }
  return _xlsxPromise;
}

/**
 * exportXlsx
 * @param {Object} opts
 * @param {function(Object): Promise<Object>|function(Object): Object} opts.buildWorkbook - билдер, который на вход получает XLSX и возвращает workbook
 * @param {string} opts.filename - имя файла (например, 'report_listeners_2025-11-04.xlsx')
 */
export async function exportXlsx({ buildWorkbook, filename }) {
  const XLSX = await loadXlsx();

  // билдер обязан вернуть корректный workbook (XLSX.utils.book_new() + добавленные листы)
  const wb = await Promise.resolve(buildWorkbook(XLSX));
  if (!wb || typeof wb !== 'object') {
    throw new Error('buildWorkbook did not return a workbook');
  }

  const wbArray = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const a = document.createElement('a');
  const url = URL.createObjectURL(blob);
  a.href = url;
  a.download = filename || 'export.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/**
 * Вспомогалка: создать workbook из массива строк (AOA)
 * @param {Object} XLSX
 * @param {string} sheetName
 * @param {Array<Array<any>>} rows
 */
export function workbookFromAoA(XLSX, sheetName, rows) {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
  return wb;
}
